import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MenuService } from '@app/core/menu/menu.service';

export const menuPolicyGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const menuService = inject(MenuService);

  if (menuService.allowedPaths.includes(state.url)) {
    return true;
  } else {
    router.navigate(["/not-allowed"]);
    return false;
  }

};
